import React from "react";

const Tip =()=>{
    return(
        <div className="border-bottom pb-6 mb-5">
            <p className="fs-xs">
                Lorem ipsum dolor sit amet, consectetur adipiscing <b>elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</b>. Ut enim ad
                minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                Excepteur sint occaecat cupidatat <b>non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</b>.
            </p>
        </div>
    )
}

export default Tip;
